import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        borderRight: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    titleContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        color: theme.palette.primary.dark,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        padding: `${theme.spacing(2.5)} ${theme.spacing(5)}`,
    },
    icon: {
        color: theme.palette.info.main,
    },
    list: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        flexGrow: 1,
        overflowY: "auto",
    },
    listItemButton: {
        maxHeight: "40px !important",
    },
    item: {
        fontFamily: "Open Sans !important",
        fontWeight: 400,
        fontSize: "14px !important",
        color: theme.palette.text.secondary,
    },
    colorCode: {
        color: theme.palette.primary.main,
        borderRadius: "50%",
        width: 25,
        height: 25,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    checkbox: {
        paddingLeft: "0 !important",
        "&.Mui-checked": {
            color: `${theme.palette.text.primary} !important`,
        },
    },
    button: {
        backgroundColor: "transparent",
        borderWidth: 0,
        padding: 0,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
        width: "100%",
    },
    failureTypesCategoryTitleBox: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    infoIcon: {
        color: theme.palette.primary.dark,
        width: "16px !important",
        height: "16px !important",
    },
    failureTypesCategoryTitle: {
        textAlign: "left",
        color: theme.palette.primary.dark,
        fontStyle: "italic",
        fontSize: "15px !important",
        padding: `${theme.spacing(0.5)} ${theme.spacing(2)} ${theme.spacing(0.5)} ${theme.spacing(8)}`,
    },
    selectAllOption: {
        textAlign: "left",
        color: theme.palette.primary.dark,
        fontStyle: "italic",
        fontSize: "15px !important",
    },
    deleteIcon: {
        width: "min-content !important",
        height: "min-content !important",
        "& > svg": {
            fontSize: "16px !important",
        },
    },
}));
